import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import BumperVideos from "./BumperVideos";
import PersonalizedChannel from "./PersonalizedChannel";
import { PageRoutes } from "../../Utils/constant";
import { useLocation, useNavigate } from "react-router-dom";
import { TabContext, TabList, TabPanel } from "@mui/lab";

const Setting = () => {
  const location = useLocation();

  const [value, setValue] = React.useState<string | number>(
    location.pathname || PageRoutes.SettingBumperVideo
  );
  const navigate = useNavigate();
  const handleChange = (event: React.SyntheticEvent, newValue: any) => {
    navigate(newValue);
    setValue(newValue);
  };
  return (
    <TabContext value={value}>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Bumper Video" value={PageRoutes.SettingBumperVideo} />
            <Tab
              label="Personalized Channel"
              value={PageRoutes.SettingPersonalizedChannel}
            />
          </TabList>
        </Box>
        <TabPanel value={PageRoutes.SettingBumperVideo}>
          <BumperVideos />
        </TabPanel>
        <TabPanel value={PageRoutes.SettingPersonalizedChannel}>
          <PersonalizedChannel />
        </TabPanel>
      </Box>
    </TabContext>
  );
};
export default Setting;
